<template>
  <div class="hb-upload-document-dialog">
    <!-- 编辑选校 -->
    <el-dialog :visible.sync="openDialog" width="50%" :title="content.title" center destroy-on-close>
      <div>
        <el-form ref="form" label-width="80px" >
          <el-form-item label="文件" required>
            <el-upload
            :drag="true"
              :auto-upload="false"
              class="upload-demo"
              action="#"
              :on-change="function (file,fileList){ return handleChange(file,fileList) }"
              :on-remove="handleRemove"
              :file-list="fileList"
              :on-exceed="handleExceed"
              :limit="1"

            >
            <div v-if="!fileList || fileList.length == 0" class="control-wrapper">
              <el-button  size="small" >添加</el-button>
              <div  class="tip-text">
                <!-- * 仅限上传<span style="color: red">pdf/docx</span>; -->
<!--                建议上传PDF格式，内容清晰，大小不超过<span style="color: red">{{up_size}}mb</span>-->
                {{ fileTipMsg }}
              </div>
            </div>
            </el-upload>
          </el-form-item>
          <el-form-item label="名称" required>
            <el-input v-model="content.name" placeholder="请输入文件名称"></el-input>
          </el-form-item>
          <el-form-item label="备注" required  v-if="content.type == 'cvu'">
            <el-input
              type="text"
              v-model="content.remarks"
              placeholder="请输入备注"
            ></el-input>
          </el-form-item>
          <el-form-item label="版本" v-if="document_status" required>
            <el-radio-group v-model="content.document_status">
              <el-radio :label="1">终稿</el-radio>
              <el-radio :label="2">草稿</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="openDialog = false">取 消</el-button>
        <el-button type="primary" @click="lookScores" :loading="submitLoading">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { add_document } from "@/api/mycenter_studyabroad";
import { upload } from '@/api/public'
import {email_code} from "../../../api/mycenter";
export default {
  data() {
    return {
      document_status: false,
      submitLoading:false,
      title: '',
      name: '',
      id: '',
      fileList: [],
      openDialog: false,
      loading: false,
      // up_type: ['pdf', 'word', 'docx'],
      up_size: 6,
      content: {
        remarks: '',
        type: '',
        title: '',
        name: '',
        con: '',
        operate: '',
        document_status: '',
        id: ''
      }
    }
  },
  created() {

  },
  methods: {
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制上传最多1个文件`)
    },
    sendItem(content) {
      if (content.type == 'ps' || content.type == 'cv'  || content.type == 'rl'|| content.type == 'rpu' ){
        this.document_status = true;
        this.content.document_status = '';
      } else {
        this.document_status = false;
        this.content.document_status = '';
      }
      this.content.name = ''
      this.content.remarks = ''
      this.content = content
      this.openDialog = true
    },
    lookScores() {
      if (this.document_status && !this.content.document_status) {
        this.$message.error('还未选择版本状态')
        return
      }
      if (!this.content.name) {
        this.$message.error('文件名称不能为空')
        return
      }
      if (this.fileList.length === 0) {
        this.$message.error('还未上传文件')
        return
      }
      if(this.content && this.content.type == "info"){
        let upload_name = this.fileList[0].name;
        let extension = upload_name.split('.').pop().toLowerCase();
        if((this.content && this.content.type_name == "白底证件照(香港)" ) || (this.content && this.content.type_name == "身份证彩色扫描件" )){
          if(extension !== 'jpg'){
            this.$message.error("需要上传JPG格式的图片");
            return;
          }
        }else {
          if(extension !== 'pdf'){
            this.$message.error("需要上传PDF格式的材料");
            return;
          }
        }
      }
      const file = this.fileList[0]
      this.filesSubmit(file.raw,file.uid)
    },
    handleChange(file,fileList) {
      if (this.up_size) {
        if ((file.raw.size / 1024 / 1024) > this.up_size) {
          this.$message.error(`文件大小超过了${this.up_size}mb，无法上传`)
          this.fileList = []
          return false
        }
      }
      this.fileList = fileList
      if (this.fileList && this.fileList.length > 0) {
        const f = this.fileList[0]
        this.content.name = f.name
      }
    },
    filesSubmit(_files,_uid) { // 文件上传
      this.submitLoading = true
      const formser = new FormData() // 获取表单的参数
      formser.append('path', 'admin_file')
      formser.append('file', _files)
      upload(formser)
        .then(response => {
          this.fileList.forEach(data => {
            if (data.uid === _uid)
            return data.url = response.data
          })
          this.add_document();
        })
        .catch(error => {
          this.submitLoading = false
          this.$message.error(error.message)
        })
    },
    add_document() {
      add_document({ 'content': this.content, 'document': this.fileList })
        .then(response => {
          console.log(response);
          this.submitLoading = false
          this.fileList = []
          this.$emit('show_list', null)
          this.openDialog = false
          if (response && response.code && response.code == 200) {
            this.$message.success('上传成功')
          }
          this.content.name = ""
        })
        .catch(error => {
          this.submitLoading = false
          this.$message.error(error.message)
        })
    },

    /**
     *
     * @param file 删除内容
     * @param fileList  剩下的内容
     */
    handleRemove(file, fileList) {
      this.fileList = fileList
      console.log(file)
      console.log(fileList)
    }

  },
  computed: {
    fileTipMsg() {
      if(!this.content){
        this.up_size = 10;
        return `建议上传PDF格式，内容清晰，大小不超过${this.up_size}mb`;
      }

      if (
        this.content.type == "ps" ||
        this.content.type == "cv" ||
        this.content.type == "rp" ||
        this.content.type == "tc" ||
        this.content.type == "tcs" ||
        this.content.type == "rl"
      ) {
        this.up_size = 10;
        return `大小不超过${this.up_size}mb`;
      } else if(this.content.type == "info") {
        this.up_size = 2;
        if(this.content.type_name == "白底证件照(香港)" || this.content.type_name == "身份证彩色扫描件"){
          return `需要上传JPG格式，内容清晰，大小不超过${this.up_size}mb`;
        }else {
          return `需要上传PDF格式，内容清晰，大小不超过${this.up_size}mb`;
        }
      }else {
        this.up_size = 10;
        return `建议上传PDF格式，内容清晰，大小不超过${this.up_size}mb`;
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.hb-upload-document-dialog {
  .upload-demo {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    .el-upload-list {
      max-width: 100%;
    }
    .control-wrapper {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
      .tip-text {
        font-size: 12px;
        color: #909399;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/mycenter_studyabroad/component/upload_document.vue